import React, { useState } from 'react'

import { Dashboard } from '@components/common'
import { Button, Dropdown } from '@fourthwall/components'
import { CalendarIcon } from '@fourthwall/icons'
import { StatGroup } from '@fourthwall/module-analytics'

import { useOverviewContext } from '../../hooks/useOverviewContext'
import { AnalyticsSkeleton } from './AnalyticsSkeleton'
import { MembersChangeChart } from './components/MembersChangeChart/MembersChangeChart'
import { MembersTotalChart } from './components/MembersTotalChart/MembersTotalChart'
import { ProfitChart } from './components/ProfitChart/ProfitChart'
import { TABS } from './consts'
import * as S from './styled'

export const Analytics = () => {
  const overview = useOverviewContext()

  const [range, setRange] = useState(30)
  const [isOpen, setIsOpen] = useState(false)

  if (overview.isLoading || overview.hasAnyTier === null) return <AnalyticsSkeleton />

  if (overview.hasAnyTier === false) return null

  if (overview.onboarding.active) return null

  const dropdownContent = (
    <S.DropdownContent>
      {TABS.map((tab) => (
        <Dropdown.Item
          key={tab.value}
          label={tab.label}
          active={tab.value === range}
          onClick={() => {
            setIsOpen(false)
            setRange(Number(tab.value))
          }}
          cursor="pointer"
        />
      ))}
    </S.DropdownContent>
  )

  return (
    <div>
      <div style={{ marginBottom: 24, justifySelf: 'start' }}>
        <Dropdown
          content={dropdownContent}
          position="bottom-start"
          maxWidth={280}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        >
          <Button
            size="xsmall"
            appearance="secondary"
            label={TABS.find((tab) => tab.value === range)?.label || ''}
            leftIcon={<CalendarIcon />}
            onClick={() => setIsOpen(!isOpen)}
          />
        </Dropdown>
      </div>
      <Dashboard.Section.ScrollableContent hideScrollbar fullWidth>
        <StatGroup>
          <S.Stat>
            <MembersTotalChart range={range} />
          </S.Stat>
          <S.Stat>
            <MembersChangeChart range={range} />
          </S.Stat>
          <S.Stat>
            <ProfitChart
              label={TABS.find((tab) => tab.value === range)?.profitChartLabel || 'Profit'}
              range={range}
            />
          </S.Stat>
        </StatGroup>
      </Dashboard.Section.ScrollableContent>
    </div>
  )
}
